/** @file Hit test of a screen point against gizmo handles; the first handle in list order wins. */
import { trig } from '@pose2d/math/trig';
import { pointSegmentDistance } from './_internal/pointSegmentDistance';
import type { GizmoHandle, GizmoPart } from './gizmoHandles';

/** True when screen point (sx, sy) is on handle h. */
function onHandle(h: GizmoHandle, sx: number, sy: number): boolean {
  switch (h.shape) {
    case 'disc':
      return trig.hypot(sx - h.center[0], sy - h.center[1]) <= h.radius;
    case 'segment':
      return pointSegmentDistance(sx, sy, h.a[0], h.a[1], h.b[0], h.b[1]) <= h.radius;
    case 'ring':
      return Math.abs(trig.hypot(sx - h.center[0], sy - h.center[1]) - h.radius) <= h.band;
  }
}

/** Part of the first handle under (sx, sy), or null when the point misses the gizmo. */
export function hitGizmo(handles: readonly GizmoHandle[], sx: number, sy: number): GizmoPart | null {
  for (const h of handles) {
    if (onHandle(h, sx, sy)) return h.part;
  }
  return null;
}
